/// <reference path="../typings/index.d.ts" />

declare var MultiSelect: any;

interface IDocsAdminFlash {
    type: 'success' | 'error' | 'info';
    message: string;
}

interface Window {
    docsAdminFlash?: IDocsAdminFlash;
    DocsEditorConfig?: {
        uploadUrl: string;
        uploadCapaUrl: string;
        previewUrl: string;
        artigoId: number | null;
        uploadToken: string;
        uploadMaxBytes: number;
        uploadMaxMessage: string;
        csrfToken: string;
    };
}

namespace App.Docs {
    export class AdminUx {
        private static overlayVisivel = false;

        public static inicializar(): void {
            AdminUx.exibirFlashSessao();
            AdminUx.configurarFormularios();
            AdminUx.configurarCategoriasAdicionais();
            AdminUx.configurarUploadCapa();
            AdminUx.rolarParaAlertas();
        }

        private static configurarCategoriasAdicionais(): void {
            var select = document.querySelector('[data-docs-categorias-adicionais]') as HTMLSelectElement | null;
            if (!select || typeof MultiSelect !== 'function') {
                return;
            }

            new MultiSelect(select, {
                placeholder: 'Selecione uma ou mais categorias',
                search: true,
                selectAll: false,
                listAll: true,
                closeListOnItemSelect: false,
                theme: 'light',
            });

            var busca = document.querySelector('.docs-categorias-adicionais .multi-select-search') as HTMLInputElement | null;
            if (busca) {
                busca.placeholder = 'Buscar categorias...';
                busca.setAttribute('aria-label', 'Buscar categorias adicionais');
            }
        }

        public static obterCategoriaSlugSelecionada(): string {
            var select = document.querySelector('[name="categoria_id"]') as HTMLSelectElement | null;
            if (!select || !select.value) {
                return '';
            }

            var option = select.options[select.selectedIndex];
            return option ? String(option.getAttribute('data-slug') || '') : '';
        }

        public static validarTamanhoImagem(file: File, config?: Window['DocsEditorConfig']): boolean {
            var cfg = config || window.DocsEditorConfig;
            var maxBytes = (cfg && cfg.uploadMaxBytes) ? cfg.uploadMaxBytes : (2 * 1024 * 1024);
            var mensagem = (cfg && cfg.uploadMaxMessage)
                ? cfg.uploadMaxMessage
                : 'A imagem deve ter no máximo 2 MB. Escolha um arquivo menor ou comprima a imagem antes de enviar.';

            if (file.size > maxBytes) {
                AdminUx.notificarErro(mensagem);
                return false;
            }

            return true;
        }

        private static configurarUploadCapa(): void {
            var config = window.DocsEditorConfig;
            var fileInput = document.getElementById('imagem-capa-file') as HTMLInputElement | null;
            var caminhoInput = document.getElementById('imagem-capa-caminho') as HTMLInputElement | null;
            var removerInput = document.getElementById('remover-imagem-capa') as HTMLInputElement | null;
            var previewWrap = document.getElementById('imagem-capa-preview-wrap');
            var previewImg = document.getElementById('imagem-capa-preview') as HTMLImageElement | null;
            var removerBtn = document.getElementById('imagem-capa-remover');
            var statusEl = document.getElementById('imagem-capa-status');

            if (!config || !fileInput || !caminhoInput || !config.uploadCapaUrl) {
                return;
            }

            if (removerBtn) {
                $(removerBtn).on('click', function () {
                    caminhoInput.value = '';
                    if (removerInput) {
                        removerInput.value = '1';
                    }
                    if (fileInput) {
                        fileInput.value = '';
                    }
                    if (previewImg) {
                        previewImg.removeAttribute('src');
                    }
                    if (previewWrap) {
                        previewWrap.classList.add('d-none');
                    }
                    if (statusEl) {
                        statusEl.textContent = 'A imagem de capa será removida ao salvar.';
                        statusEl.classList.remove('d-none');
                    }
                });
            }

            $(fileInput).on('change', function () {
                var input = this as HTMLInputElement;
                if (!input.files || !input.files[0]) {
                    return;
                }

                var file = input.files[0];

                App.Docs.ImageUploadLog.dadosArquivo(file, 'capa-tutorial');

                if (!AdminUx.validarTamanhoImagem(file, config)) {
                    App.Docs.ImageUploadLog.warn('capa-rejeitada-tamanho', {});
                    input.value = '';
                    return;
                }

                if (statusEl) {
                    statusEl.textContent = 'Enviando capa...';
                    statusEl.classList.remove('d-none');
                }

                var formData = new FormData();
                formData.append('arquivo', file);
                formData.append('_token', config.csrfToken);

                if (config.artigoId) {
                    formData.append('artigo_id', String(config.artigoId));
                }
                if (config.uploadToken) {
                    formData.append('upload_token', config.uploadToken);
                }

                var slugInput = document.querySelector('[name="slug"]') as HTMLInputElement | null;
                if (slugInput && slugInput.value.trim() !== '') {
                    formData.append('slug', slugInput.value.trim());
                }

                var categoriaSlug = AdminUx.obterCategoriaSlugSelecionada();
                if (categoriaSlug) {
                    formData.append('categoria_slug', categoriaSlug);
                }

                App.Docs.ImageUploadLog.info('capa-upload-iniciado', {
                    url: config.uploadCapaUrl,
                    artigo_id: config.artigoId,
                    upload_token: config.uploadToken,
                    slug: slugInput && slugInput.value.trim() !== '' ? slugInput.value.trim() : '',
                    categoria_slug: categoriaSlug,
                });

                $.ajax({
                    url: config.uploadCapaUrl,
                    method: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                }).done(function (response: { sucesso?: boolean; url?: string; caminho?: string; mensagem?: string; docs_img_upload_log?: any[] }) {
                    input.value = '';

                    App.Docs.ImageUploadLog.info('capa-upload-resposta', {
                        sucesso: !!(response && response.sucesso),
                        url: response && response.url ? response.url : null,
                        caminho: response && response.caminho ? response.caminho : null,
                    });

                    if (response && response.docs_img_upload_log) {
                        App.Docs.ImageUploadLog.servidor(response.docs_img_upload_log);
                    }

                    if (response && response.sucesso && response.caminho && response.url) {
                        caminhoInput.value = response.caminho;
                        if (removerInput) {
                            removerInput.value = '0';
                        }
                        if (previewImg) {
                            previewImg.src = response.url;
                        }
                        App.Docs.ImageUploadLog.verificarUrlImagem(response.url, 'capa-tutorial-preview');
                        if (previewWrap) {
                            previewWrap.classList.remove('d-none');
                        }
                        if (statusEl) {
                            statusEl.textContent = 'Capa enviada com sucesso.';
                        }
                        AdminUx.notificarSucesso('Capa enviada com sucesso.');
                        return;
                    }

                    if (statusEl) {
                        statusEl.textContent = '';
                        statusEl.classList.add('d-none');
                    }
                    AdminUx.notificarErro((response && response.mensagem) || 'Falha ao enviar a capa.');
                }).fail(function (xhr: JQueryXHR) {
                    input.value = '';
                    var msg = 'Falha ao enviar a capa.';
                    var response = xhr.responseJSON as { mensagem?: string; docs_img_upload_log?: any[] };
                    if (response && response.mensagem) {
                        msg = response.mensagem;
                    }

                    App.Docs.ImageUploadLog.error('capa-upload-falhou', {
                        status: xhr.status,
                        mensagem: msg,
                    });

                    if (response && response.docs_img_upload_log) {
                        App.Docs.ImageUploadLog.servidor(response.docs_img_upload_log);
                    }

                    if (statusEl) {
                        statusEl.textContent = '';
                        statusEl.classList.add('d-none');
                    }
                    AdminUx.notificarErro(msg);
                });
            });
        }

        private static rolarParaAlertas(): void {
            var alerta = document.querySelector('.docs-admin-main .alert');
            if (alerta) {
                alerta.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }

        private static getToastr(): any {
            return (window as any).toastr;
        }

        private static exibirFlashSessao(): void {
            var flash = window.docsAdminFlash;
            if (!flash || !flash.message) {
                return;
            }

            var toastrLib = AdminUx.getToastr();
            if (toastrLib) {
                toastrLib.options = {
                    closeButton: true,
                    progressBar: true,
                    timeOut: 5000,
                    positionClass: 'toast-top-right',
                };

                if (flash.type === 'success') {
                    toastrLib.success(flash.message, 'Sucesso');
                } else if (flash.type === 'error') {
                    toastrLib.error(flash.message, 'Erro');
                } else {
                    toastrLib.info(flash.message, 'Aviso');
                }
            }
        }

        private static configurarFormularios(): void {
            var $area = $('.docs-admin-body');
            if (!$area.length) {
                return;
            }

            $area.on('submit', 'form', function (e: JQueryEventObject) {
                var $form = $(this);

                if ($form.data('docsConfirm')) {
                    var msg = String($form.data('docsConfirm'));
                    if (!window.confirm(msg)) {
                        e.preventDefault();
                        return false;
                    }
                }

                if ($form.data('docsSubmitting')) {
                    e.preventDefault();
                    return false;
                }

                $form.data('docsSubmitting', true);

                var $clicked = $(document.activeElement);
                var $btn = $clicked.is('button[type="submit"], input[type="submit"]')
                    ? $clicked
                    : $form.find('button[type="submit"], input[type="submit"]').first();

                var loadingText = $btn.data('loadingText')
                    || $form.data('loadingText')
                    || AdminUx.textoPadrao($form);

                $form.find('button[type="submit"], input[type="submit"]').prop('disabled', true);
                $form.find('a.btn').addClass('disabled').attr('aria-disabled', 'true').on('click.docsAdmin', function (e) {
                    e.preventDefault();
                });

                AdminUx.mostrarOverlay(loadingText);

                return true;
            });
        }

        private static textoPadrao($form: JQuery): string {
            var acao = String($form.data('docsAction') || '').toLowerCase();

            if (acao === 'delete' || acao === 'destroy') {
                return 'Excluindo...';
            }
            if (acao === 'publish') {
                return 'Publicando...';
            }
            if (acao === 'unpublish') {
                return 'Despublicando...';
            }
            if (acao === 'filter') {
                return 'Filtrando...';
            }
            if ($form.attr('method') && $form.attr('method').toUpperCase() === 'GET') {
                return 'Carregando...';
            }

            return 'Salvando...';
        }

        public static mostrarOverlay(texto: string): void {
            var $overlay = $('#docs-admin-loading');
            if (!$overlay.length) {
                return;
            }

            $('body.docs-admin-body').addClass('docs-admin-is-loading');
            $overlay.find('.docs-admin-loading__text').text(texto || 'Processando...');
            $overlay.addClass('is-visible').attr('aria-hidden', 'false').attr('aria-busy', 'true');
            AdminUx.overlayVisivel = true;
        }

        public static ocultarOverlay(): void {
            var $overlay = $('#docs-admin-loading');
            $overlay.removeClass('is-visible').attr('aria-hidden', 'true').attr('aria-busy', 'false');
            $('body.docs-admin-body').removeClass('docs-admin-is-loading');
            AdminUx.overlayVisivel = false;
        }

        public static notificarSucesso(mensagem: string, titulo?: string): void {
            var toastrLib = AdminUx.getToastr();
            if (toastrLib) {
                toastrLib.success(mensagem, titulo || 'Sucesso');
                return;
            }
            alert(mensagem);
        }

        public static notificarErro(mensagem: string, titulo?: string): void {
            var toastrLib = AdminUx.getToastr();
            if (toastrLib) {
                toastrLib.error(mensagem, titulo || 'Erro');
                return;
            }
            alert(mensagem);
        }
    }
}

$(document).ready(function () {
    if (typeof App !== 'undefined' && App.Docs && App.Docs.ImageUploadLog && (window as any).docsImgUploadLogSessao) {
        App.Docs.ImageUploadLog.info('logs-da-sessao-apos-salvar-formulario', {});
        App.Docs.ImageUploadLog.servidor((window as any).docsImgUploadLogSessao);
    }

    if ($('.docs-admin-body').length) {
        App.Docs.AdminUx.inicializar();
    }
});
